import React from 'react';
import PropTypes from 'prop-types';
import css from './InstructionsToUse.module.css';

const InstructionsToUse = ({ content }) => {
    return (
        <div className={css.panel}>
            <h4 className={css.heading}>Instructions to Use</h4>
            <div className={css.content} dangerouslySetInnerHTML={{ __html: content }} />
        </div>
    );
};

InstructionsToUse.propTypes = {
    content: PropTypes.string.isRequired,
};

export default InstructionsToUse; 